

(function($) {

    skel
        .breakpoints({
            xlarge: '(max-width: 1680px)',
            large: '(max-width: 1280px)',
            medium: '(max-width: 980px)',
            small: '(max-width: 736px)',
            xsmall: '(max-width: 480px)'
        });

    $(function() {

        var $window = $(window),
            $body = $('body'),
            $wrapper = $('#page-wrapper'),
            $banner = $('#banner'),
            $header = $('#header');

        // Disable animations/transitions until the page has loaded.
        $body.addClass('is-loading');

        $window.on('load', function() {
            window.setTimeout(function() {
                $body.removeClass('is-loading');
            }, 100);
        });


        // lazy loading images
        var bLazy = new Blazy({
                folder: "images/",
                breakpoints: [480,736,980,1280,1920],
            }
        );
        var bLazy = new Blazy({
                selector: ".b-lazy-map",
                folder: "images/maps/",
                breakpoints: [480,736,980,1280,1920],
            }
        );

        // copy navi to mobile navi
        $("#nav").html( $('.pushy-content ul').clone() );


        // set random landing page image
        
        //var index = Math.floor(Math.random() * 3 + 1); 
        // remove first for tag der sommerfrische
        var index = Math.floor(Math.random() * 2 + 2); 

        var scale = 1920;
        var isRetina = window.devicePixelRatio > 1;
        var winWidth = isRetina ? window.innerWidth*2 : window.innerWidth;
        $([480,736,980,1280,1920]).each(function(i,w) {
            //console.log('test', w, window.innerWidth);
            if (w >= winWidth) {
                scale = w;
                return false;
            }
        });
        $("#banner").css("background-image", "url(./../images/" + scale + "/IBA_SommerfrischeMotive_Universal0" + index + ".jpg)");


        // events
        var isMainPage = $("#Termine").length == 1;
        if (isMainPage){
            // defines markup enhancement regex
            var protocol = /(\b(https?|ftp):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gim
                , scheme   = /(^|[^\/])(www\.[\S]+(\b|$))/gim;

            Handlebars.registerHelper('breaklines', function(text) {
                text = Handlebars.Utils.escapeExpression(text);
                text = text.replace(/(\r\n|\n|\r)/gm, '<br>');

                // autolink urls
                text = text.replace( protocol, '<a href="$1" target="_blank">$1</a>');
                text = text.replace( scheme,   '$1<a href="http://$2" target="_blank">$2</a>' );

                return new Handlebars.SafeString(text);
            });




            var url = "https://sommerfrische01-2e82b.firebaseio.com/events.json";
            var slingshot = function(url, tplId, anchor) {
                $.getJSON(url, function(data) {
                    var template = $(tplId).html();
                    var stone = Handlebars.compile(template)({events: data});
                    $(anchor).append(stone);

                    $('.accordion').accordion({});
                });
            };
            slingshot(url, '#tpl', '#dates');
        }










        // Mobile?
        if (skel.vars.mobile)
            $body.addClass('is-mobile');
        else
            skel
            .on('-medium !medium', function() {
                $body.removeClass('is-mobile');
            })
            .on('+medium', function() {
                $body.addClass('is-mobile');
            });

        // Fix: Placeholder polyfill.
        //$('form').placeholder();

        // Accordion
        $('.accordion').accordion({
            "transitionSpeed": 400
        });


        // Prioritize "important" elements on medium.
        skel.on('+medium -medium', function() {
            // $.prioritize(
            //     '.important\\28 medium\\29',
            //     skel.breakpoint('medium').active
            // );
        });

        // Scrolly.
        $('.scrolly')
            .scrolly({
                speed: 1000,
                offset: $header.outerHeight()
            });



        // Header.
        if (skel.vars.IEVersion < 9)
            $header.removeClass('alt');

        if ($banner.length > 0 && $header.hasClass('alt')) {

            $window.on('resize', function() { $window.trigger('scroll'); });

            $banner.scrollex({
                bottom: $header.outerHeight() + 1,
                terminate: function() { $header.removeClass('alt'); },
                enter: function() { $header.addClass('alt'); },
                leave: function() { $header.removeClass('alt'); }
            });

        }

    });


})(jQuery);




